/**
 * CommonView
 */
import Config from '../Config';
import View from './View';
import User from '../User';
import Util from '../Util';
import GameInfo from '../GameInfo';

class CommonView extends View {

	protected _id: string;

	protected paramInfo: any;

	private writeButton: string;

	private listButton: string;

	private template: any;

	constructor( node: any, options: any, template: any ) {
		super( node, options );
		this._id = node.attr( 'id' );
		this.template = template;
	}

	public addEvent() {
		this.writeButton = `.${Config.COMMUNITY_NODE} .co-btn-write`;
		this.listButton = `.${Config.COMMUNITY_NODE} .co-btn-list`;

		jQuery( 'body' ).on( 'click', this.listButton, ( evt ) => {
			const _ref = document.referrer;
			let param = this.paramInfo.getParamIgnore( 'articleId' );
			param = ( param[ 0 ] === '&' ) ? param.substr( 1 ) : param;

			if( Config.isInfinite && _ref.indexOf('/list') !== -1 && _ref.indexOf('/my') === -1 ) {
				window.history.back();
			} else {
				location.href = Config.listPage + '?' + param;
			}
		});

		jQuery( 'body' ).on( 'click', this.writeButton, ( evt ) => {
			if ( User.isCheckNotExistGameAccount() && GameInfo.isLogined() ) {
				Config.alert( Config.L10N.alert_not_exist_gameaccount );
			} else {
				this.goToWrite();
			}
		});

		if ( Config.isTag ) {
			jQuery('body').on('click', '.view-body .tag', (evt) => {
				let _query = evt.target.textContent.replace('#', '');
				location.href = Config.tagSearchLink(encodeURIComponent(_query));
			});
		}
	}

	public goToWrite() {
		let _param = this.paramInfo.getParamIgnore( 'articleId' );
		if ( _param.indexOf('#') !== -1 ) {
			_param  = _param.substr(0, _param.indexOf('#'));
		}

		if ( Config.onHookWriteBefore() ) {
			location.href = Config.writePage + '?' + _param;
		}
	}

	public get() {
		super.getData( this.template );
	}

	public getData() {
		return Config.viewData;
	}
}

export default CommonView;
